export default __webpack_public_path__ + "static/media/Deltakelse i EU-prosjektet DiamonDT.3870cc9d.pdf";